import React, { useState } from "react";
import {
  AcUnit,
  AccountBox,
  Apartment,
  Category,
  Dashboard,
  EmojiEvents,
  Group,
  Groups,
  LocalDrink,
  Loyalty,
  MedicalInformation,
  PeopleAlt,
  Report,
} from "@mui/icons-material";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import DescriptionIcon from "@mui/icons-material/Description";
import LocalLibraryIcon from "@mui/icons-material/LocalLibrary";
import WorkIcon from "@mui/icons-material/Work";
import GroupsIcon from "@mui/icons-material/Groups";
import ClassIcon from "@mui/icons-material/Class";
import FoodBankIcon from "@mui/icons-material/FoodBank";
import LockIcon from "@mui/icons-material/Lock";
import Inventory2RoundedIcon from "@mui/icons-material/Inventory2Rounded";
import NotificationsRoundedIcon from "@mui/icons-material/NotificationsRounded";
import ShoppingCartRoundedIcon from "@mui/icons-material/ShoppingCartRounded";
import SquareFootRoundedIcon from "@mui/icons-material/SquareFootRounded";
import SettingsIcon from "@mui/icons-material/Settings";
import MeetingRoomIcon from "@mui/icons-material/MeetingRoom";

import Link from "./Link";
import { Settings } from "@mui/icons-material";

const linskData = [
  {
    label: "Application",
    routes: [
      {
        name: "Dashboard",
        label: "Dashboard",
        link: "/admin/dashboard",
        icon: <Dashboard fontSize="small" />,
      },
      {
        name: "Members",
        label: "Members",
        link: "/admin/members",
        icon: <PeopleAlt fontSize="small" />,
      },
      {
        name: "Employees",
        label: "Employees",
        link: "/admin/employees",
        icon: <PeopleAlt fontSize="small" />,
      },

      {
        name: "Packages",
        label: "Packages",
        icon: <Groups fontSize="small" />,
        children: [
          // {
          //   name: "Diet Plan Packages",
          //   label: "Diet Plan Packages",
          //   link: "/admin/dietPlanPackages",
          // },
          {
            name: "Personal Training Package",
            label: "Personal Training Package",
            link: "/admin/personalTrainingPackage",
          },
          {
            name: "Membership Packages",
            label: "Membership Packages",
            link: "/admin/membershipPackages",
          },
        ],
      },
      {
        name: "Package Bookings",
        label: "Package Bookings",
        icon: <Groups fontSize="small" />,
        children: [
          {
            name: "Personal Training Package Bookings",
            label: "Personal Training Package Bookings",
            link: "/admin/personalTrainingPackageBookings",
          },
          {
            name: "Membership Package Bookings",
            label: "Membership Package Bookings",
            link: "/admin/membershipPackageBookings",
          },
          {
            name: "Inovice Receipt",
            label: "Inovice Receipt",
            link: "/admin/invoiceReceipt",
          },
        ],
      },
      {
        name: "Freezing Memberships",
        label: "Freezing Memberships",
        icon: <AcUnit fontSize="small" />,
        link: "/admin/freezingMemberships",
      },
      {
        name: "Nutrition Plan",
        label: "Nutrition Plan",
        icon: <GroupsIcon fontSize="small" />,
        children: [
          {
            name: "Nutrition Plan",
            label: "Nutrition Plan",
            link: "/admin/dietPlanPackages",
          },
          {
            name: "Nutrition Plan Booking",
            label: "Nutrition Plan Booking",
            link: "/admin/nutritionPlanPackageBookings",
          },
          {
            name: "MealTypes",
            label: "MealTypes",
            link: "/admin/mealTypes",
            // icon: <FoodBankIcon fontSize="small" />,
          },
          {
            name: "Foods",
            label: "Foods",
            link: "/admin/foods",
          },

          // {
          //   name: "Nutrition Plan",
          //   label: "Nutrition Plan",
          //   link: "/admin/nutritionPlan",
          //   exact: true,
          // },
          // {
          //   name: "Track Nutrition Plan",
          //   label: "Track Nutrition Plan",
          //   link: "/admin/trackNutritionPlan",
          //   exact: true,
          // },
        ],
      },
      {
        name: "AllBodyMeasurementTracks",
        label: "BodyMeasurement Tracks",
        link: "/admin/allBodyMeasurementTracks",
        icon: <WorkIcon fontSize="small" />,
      },

      {
        name: "Classes",
        label: "Classes",
        icon: <ClassIcon fontSize="small" />,
        children: [
          {
            name: "Classes",
            label: "Classes",
            link: "/admin/classes",
            exact: true,
          },
          {
            name: "Schedule Classes",
            label: "Schedule Classes",
            link: "/admin/scheduleClasses",
            exact: true,
          },
          {
            name: "Booked Classes",
            label: "Book Classes",
            link: "/admin/bookedclasses",
            exact: true,
          },
          {
            name: "Postpone Class",
            label: "Postpone Class",
            link: "/admin/postponeClass/create",
            exact: true,
          },
          {
            name: "ClassWorkout",
            label: "Class Workouts",
            link: "/admin/classWorkouts",
            exact: true,
          },
          // {
          //   name: "Class Workouts",
          //   label: "Class Workouts",
          //   link: "/admin/classWorkout/create",
          //   exact: true,
          // },
          // {
          //   name: "Trainer Classes",
          //   label: "Trainer Classes",
          //   link: "/admin/trainerClasses",
          //   exact: true,
          // },
          // {
          //     name: "Booking Classes",
          //     label: "Booking Classes",
          //     link: '/admin/bookingClasses',
          //     exact: true
          // },
        ],
      },
      {
        name: "Attendances",
        label: "Attendances",
        icon: <LocalLibraryIcon fontSize="small" />,
        children: [
          {
            name: "Employee Attendances",
            label: "Employee Attendances",
            link: "/admin/employeeAttendances",
            exact: true,
          },
          {
            name: "Gym Member Attendances",
            label: "Gym Member Attendances",
            link: "/admin/memberAttendances",
            exact: true,
          },
          // {
          //   name: "Class Attendance",
          //   label: "Class Attendance",
          //   link: "/admin/classAttendance/create",
          //   exact: true,
          // },
          // {
          //   name: "Class Member Attendances",
          //   label: "Class Member Attendances",
          //   link: "/admin/classMemberAttendance/create",
          //   exact: true,
          // },
        ],
      },

      {
        name: "Workout",
        label: "Workout",
        icon: <WorkIcon fontSize="small" />,
        children: [
          {
            name: "Workout",
            label: "Workout",
            link: "/admin/workOut",
          },
          {
            name: "All Workout Category",
            label: " Workout Categories",
            link: "/admin/workOutCategory",
          },
        ],
      },
      // {
      //   name: "Training Session",
      //   label: "Training Session",
      //   icon: <LockIcon fontSize="small" />,
      //   children: [
      //     {
      //       name: "CheckIn Sessions",
      //       label: "CheckIn Sessions",
      //       link: "/admin/sessionAttendances",
      //       exact: true,
      //     },
      //     {
      //       name: "Personal training sessions",
      //       label: "Personal training sessions",
      //       link: "/admin/personalTrainingSessions",
      //     },
      //     {
      //       name: "All Sessions",
      //       label: "All Sessions",
      //       link: "/admin/session",
      //     },
      //     {
      //       name: "Session Workouts",
      //       label: "Session Workouts",
      //       link: "/admin/sessionWorkout/create",
      //     },
      //   ],
      // },

      // {
      //   name: "Purchases",
      //   label: "Purchases",
      //   icon: <ShoppingCartRoundedIcon fontSize="small" />,
      //   children: [
      //     {
      //       name: "Orders",
      //       label: "Orders",
      //       link: "/admin/purchaseOrders",
      //     },
      //     {
      //       name: "Returns",
      //       label: "Returns",
      //       link: "/admin/purchaseReturns",
      //     },
      //     {
      //       name: "Receipts",
      //       label: "Receipts",
      //       link: "/admin/purchaseReceipts",
      //     },
      //     {
      //       name: "Suppliers",
      //       label: "Suppliers",
      //       link: "/admin/suppliers",
      //     },
      //   ],
      // },
      // {
      //   name: "Sells",
      //   label: "Sells",
      //   icon: <ShoppingCartRoundedIcon fontSize="small" />,
      //   children: [
      //     {
      //       name: "Invoices",
      //       label: "Invoices",
      //       link: "/admin/sellInvoices",
      //     },
      //     {
      //       name: "Create Product Invoice",
      //       label: "Create Product Invoices",
      //       link: "/admin/productInvoices/create",
      //     },
      //     {
      //       name: "Create Package Invoice",
      //       label: "Create Package Invoices",
      //       link: "/admin/packageInvoices/create",
      //     },
      //     {
      //       name: "Receipts",
      //       label: "Receipts",
      //       link: "/admin/sellReceipts",
      //     },
      //     {
      //       name: "Returns",
      //       label: "Returns",
      //       link: "/admin/sellReturns",
      //     },
      //     {
      //       name: "Customers",
      //       label: "Customers",
      //       link: "/admin/customers",
      //     },
      //   ],
      // },
      {
        name: "Products",
        label: "Products",
        icon: <Inventory2RoundedIcon fontSize="small" />,
        children: [
          {
            name: "Products",
            label: "Products",
            link: "/admin/products",
          },
          {
            name: "Categories",
            label: "Categories",
            link: "/admin/categories",
          },
          {
            name: "Product UOM",
            label: "Product UOM",
            link: "/admin/UnitOfMeasure",
          },
        ],
      },
      {
        name: "All Orders",
        label: "Order",
        link: "/admin/orderlist",
        icon: <FoodBankIcon fontSize="small" />,
      },
      // {
      //   name: "ProductsWithUOMStock",
      //   label: "ProductsWithUOMStock",
      //   link: "/admin/productsWithUOMStock",
      //   icon: <Inventory2RoundedIcon fontSize="small" />,
      // },
      // {
      //     name: "PersonalTrainingBookings",
      //     label: "Personal Training Bookings",
      //     link: '/admin/personalTrainingBookings',
      //     icon: <WorkIcon fontSize="small" />,
      // },
      // {
      //     name: "PaymentHistory",
      //     label: "Payment History",
      //     link: '/admin/paymentHistory',
      //     icon: <WorkIcon fontSize="small" />,
      // },
      // {
      //     name: "Discount",
      //     label: "Discount",
      //     link: '/admin/discount',
      //     icon: <WorkIcon fontSize="small" />,
      // },

      // {
      //   name: "Member Workout",
      //   label: "Member Workout",
      //   link: "/admin/memberWorkouts",
      //   icon: <WorkIcon fontSize="small" />,
      // },

      // {
      //   name: "Foods",
      //   label: "Foods",
      //   link: "/admin/foods",
      //   icon: <FoodBankIcon fontSize="small" />,
      // },

      // {
      //   name: "MealTypes",
      //   label: "MealTypes",
      //   link: "/admin/mealTypes",
      //   icon: <FoodBankIcon fontSize="small" />,
      // },

      {
        name: "Accounts",
        label: "Accounts",
        icon: <DescriptionIcon fontSize="small" />,
        children: [
          {
            name: "Banks",
            label: "Banks",
            link: "/admin/bank",
          },
          // {
          //   name: "Ledger Group",
          //   label: "Ledger Group",
          //   link: "/admin/ledgerGroup",
          // },
          // {
          //   name: "Account Group",
          //   label: "Account Group",
          //   link: "/admin/accountGroup",
          // },
          // {
          //   name: "Ledger Account",
          //   label: "Ledger Account",
          //   link: "/admin/accountLedger",
          // },
          // {
          //   name: "Linking Account",
          //   label: "Linking Account",
          //   link: "/admin/linkingAccount",
          // },
          // {
          //   name: "Payment Vouchers",
          //   label: "Payment Vouchers",
          //   link: "/admin/paymentVouchers",
          // },
          // {
          //   name: "Bank Reconciliation Reminder Payment",
          //   label: "Bank Reconciliation Reminder Payment",
          //   link: "/admin/bankReconciliationReminderPayment",
          // },
          // {
          //   name: "Receipt Voucher",
          //   label: "Receipt Voucher",
          //   link: "/admin/receiptVoucher",
          // },
          // {
          //   name: "Bank Reconciliation Reminder Receipt",
          //   label: "Bank Reconciliation Reminder Receipt",
          //   link: "/admin/bankReconciliationReminderReceipt",
          // },
          // // {
          // //   name: "Journal Vouchers",
          // //   label: "Journal Vouchers",
          // //   link: "/admin/journalVouchers",
          // // },
          // {
          //   name: "Journal Entry",
          //   label: "Journal Entry",
          //   link: "/admin/journalEntry/create",
          // },
          // {
          //   name: "Depreciation Assets",
          //   label: "Depreciation Assets",
          //   link: "/admin/depreciationAssets",
          // },
          // {
          //   name: "Reports",
          //   label: "Reports",
          //   link: "",
          //   // icon: <DescriptionIcon fontSize="small" />,
          //   children: [
          //     {
          //       name: "Payment Register",
          //       label: "Payment Register",
          //       link: "/admin/paymentRegister",
          //     },
          //     {
          //       name: "Receipt Register",
          //       label: "Receipt Register",
          //       link: "/admin/receiptRegister",
          //     },
          //     {
          //       name: "Account Ledger",
          //       label: "Account Ledger",
          //       link: "/admin/accountLedgerReport",
          //     },
          //     {
          //       name: "Group Report",
          //       label: "Group Report",
          //       link: "/admin/groupReport",
          //     },
          //     {
          //       name: "Voucher Details",
          //       label: "Voucher Details",
          //       link: "/admin/voucherDetails",
          //     },
          //   ],
          // },
          // {
          //   name: "Financial statement",
          //   label: "Financial statement",
          //   // icon: <DescriptionIcon fontSize="small" />,
          //   children: [
          //     // {
          //     //   name: "Expense",
          //     //   label: "Expense",
          //     //   link: "/admin/expense",
          //     // },
          //     {
          //       name: "Profit And Loss",
          //       label: "Profit And Loss",
          //       link: "/admin/profitAndLoss",
          //     },
          //     {
          //       name: "Scheduled For Profit And Loss",
          //       label: "Scheduled For Profit And Loss",
          //       link: "/admin/scheduledForProfitAndLoss",
          //     },
          //     {
          //       name: "Balance Sheet",
          //       label: "Balance Sheet",
          //       link: "/admin/balanceSheet",
          //     },
          //     {
          //       name: "Scheduled For Balance Sheet",
          //       label: "Scheduled For Balance Sheet",
          //       link: "/admin/scheduledForBalanceSheet",
          //     },
          //     {
          //       name: "Trial Balance",
          //       label: "Trial Balance",
          //       link: "/admin/trialBalance",
          //     },
          //     {
          //       name: "Scheduled TrialBalance",
          //       label: "Scheduled TrialBalance",
          //       link: "/admin/scheduledTrialBalance",
          //     },
          //   ],
          // },
        ],
      },
      // {
      //   name: "HRMS",
      //   label: "HRMS",
      //   icon: <DescriptionIcon fontSize="small" />,
      //   children: [
      //     {
      //       name: "Masters",
      //       label: "Masters",
      //       children: [
      //         {
      //           name: "Department",
      //           label: "Department",
      //           link: "/admin/department",
      //         },
      //         {
      //           name: "Marital Status",
      //           label: "Marital Status",
      //           link: "/admin/maritalStatus",
      //         },
      //         {
      //           name: "Deduction Type",
      //           label: "Deduction Type",
      //           link: "/admin/deductionType",
      //         },
      //         {
      //           name: "Leave Type",
      //           label: "Leave Type",
      //           link: "/admin/leaveType",
      //         },
      //       ],
      //     },
      //     {
      //       name: "Utilities",
      //       label: "Utilities",
      //       children: [
      //         {
      //           name: "Employee Bank Details",
      //           label: "Employee Bank Details",
      //           link: "/admin/employeeBank",
      //         },
      //         {
      //           name: "Employee Family Details",
      //           label: "Employee Family Details",
      //           link: "/admin/employeeFamily",
      //         },
      //         {
      //           name: "Employee Overtime",
      //           label: "Employee Overtime",
      //           link: "/admin/overTime",
      //         },
      //         {
      //           name: "Employee Settlement",
      //           label: "Employee Settlement",
      //           link: "/admin/employeeSettlement",
      //         },
      //         {
      //           name: "Employee Deduction",
      //           label: "Employee Deduction",
      //           link: "/admin/employeeDeduction",
      //         },
      //         {
      //           name: "Employee Bonus",
      //           label: "Employee Bonus",
      //           link: "/admin/employeeBonus",
      //         },
      //         {
      //           name: "Employee Loan",
      //           label: "Employee Loan",
      //           link: "/admin/employeeLoan",
      //         },
      //         {
      //           name: "Employee Leave",
      //           label: "Employee Leave",
      //           link: "/admin/employeeLeave",
      //         },
      //         {
      //           name: "Resign",
      //           label: "Resign",
      //           link: "/admin/resign",
      //         },
      //       ],
      //     },
      //     // {
      //     // name: "Reports",
      //     // label: "Reports",
      //     // children: [
      //     // {
      //     //   name: "Salary Statement",
      //     //   label: "Salary Statement",
      //     //   link: "/admin/salaryStatement",
      //     // },
      //     // {
      //     //   name: "Employee Commissions",
      //     //   label: "Employee Commissions",
      //     //   link: "/admin/employeeCommissions",
      //     // },
      //     // {
      //     //   name: "Attendance",
      //     //   label: "Attendance",
      //     //   children: [
      //     //     {
      //     //       name: "Attendance Report",
      //     //       label: "Attendance Report",
      //     //       link: "/admin/attendanceReport",
      //     //     },
      //     //     {
      //     //       name: "Over Time Report",
      //     //       label: "Over Time Report",
      //     //       link: "/admin/overTimeReport",
      //     //     },
      //     //   ]
      //     // },
      //     // {
      //     //   name: "Salary",
      //     //   label: "Salary",
      //     //   children: [
      //     //     {
      //     //       name: "Salary Statement",
      //     //       label: "Salary Statement",
      //     //       link: "/admin/salaryStatement",
      //     //     },
      //     //     {
      //     //       name: "Employee Commissions",
      //     //       label: "Employee Commissions",
      //     //       link: "/admin/employeeCommissions",
      //     //     },
      //     //   ]
      //     // },
      //     // {
      //     //   name: "Employee Reports",
      //     //   label: "Employee Reports",
      //     //   children: [
      //     //     {
      //     //       name: "Family Report",
      //     //       label: "Family Report",
      //     //       link: "/admin/familyReport",
      //     //     },
      //     //     {
      //     //       name: "Bank Report",
      //     //       label: "Bank Report",
      //     //       link: "/admin/bankReport",
      //     //     },
      //     //     {
      //     //       name: "Contact Report",
      //     //       label: "Contact Report",
      //     //       link: "/admin/contactReport",
      //     //     },
      //     //     {
      //     //       name: "Resign Report",
      //     //       label: "Resign Report",
      //     //       link: "/admin/resignReport",
      //     //     },
      //     //     {
      //     //       name: "Loan Report",
      //     //       label: "Loan Report",
      //     //       link: "/admin/loanReport",
      //     //     },
      //     //     {
      //     //       name: "Leave Report",
      //     //       label: "Leave Report",
      //     //       link: "/admin/leaveReport",
      //     //     },
      //     //     {
      //     //       name: "Expiry Report",
      //     //       label: "Expiry Report",
      //     //       link: "/admin/expiryReport",
      //     //     },
      //     //   ]
      //     // }
      //     // ],
      //     // },
      //   ],
      // },

      // {
      //   name: "Department",
      //   label: "Department",
      //   link: "/admin/department",
      //   icon: <Group fontSize="small" />,
      // },
      {
        name: "Notification",
        label: "Notification",
        icon: <NotificationsRoundedIcon fontSize="small" />,
        children: [
          {
            name: "Notification",
            label: "Notification",
            link: "/admin/notification",
            exact: true,
          },
          {
            name: "notification Template",
            label: "Notification Template",
            link: "/admin/notificationTemplate",
            exact: true,
          },
        ],
      },
      {
        name: "Core Data",
        label: "Core Data",
        icon: <SettingsIcon fontSize="small" />,
        children: [
          {
            name: "Gender",
            label: "Gender",
            link: "/admin/coreData/gender",
          },
          {
            name: "Room",
            label: "Room",
            link: "/admin/coreData/room",
          },
          {
            name: "Uom",
            label: "Uom",
            link: "/admin/setting/coreData/uom",
          },
          {
            name: "Address Type",
            label: "Address Type",
            link: "/admin/setting/coreData/addressType",
          },
          // {
          //   name: "Payment Type",
          //   label: "Payment Type",
          //   link: "/admin/setting/coreData/paymentType"
          // },
          {
            name: "Department",
            label: "Department",
            link: "/admin/department",
          },
          {
            name: "Duration Type",
            label: "Duration Type",
            link: "/admin/setting/coreData/packageDurationType",
          },
          {
            name: "Product Type",
            label: "Product Type",
            link: "/admin/setting/coreData/productType",
          },
          {
            name: "Disease Type",
            label: "Disease Type",
            link: "/admin/setting/coreData/diseaseType",
          },
          {
            name: "Designation Type",
            label: "Designation Type",
            link: "/admin/setting/coreData/designationType",
          },
          {
            name: "Country",
            label: "Country",
            link: "/admin/setting/coreData/country",
          },
          {
            name: "Region",
            label: "Region",
            link: "/admin/setting/coreData/region",
          },
          {
            name: "City",
            label: "City",
            link: "/admin/setting/coreData/city",
          },
        ],
      },
      // {
      //   name: "Locker",
      //   label: "Locker",
      //   icon: <LockIcon fontSize="small" />,
      //   children: [
      //     {
      //       name: "Locker",
      //       label: "Locker",
      //       link: "/admin/locker",
      //       exact: true,
      //     },
      //     {
      //       name: "LockerMember",
      //       label: "LockerMember",
      //       link: "/admin/lockerMember",
      //       exact: true,
      //     },
      //     // {
      //     //   name: "LockerTrack",
      //     //   label: "LockerTrack",
      //     //   link: "/admin/lockerTrack",
      //     //   exact: true,
      //     // },
      //   ],
      // },
      {
        name: "Profile Verification",
        label: "Profile Verification",
        link: "/admin/profileVerification",
        icon: <AccountBox fontSize="small" />,
      },
      {
        name: "Company Details",
        label: "Company Details",
        link: "/admin/company",
        icon: <Apartment fontSize="small" />,
      },
      {
        name: "Loyalty Points Tracks",
        label: "Loyalty Points Tracks",
        link: "/admin/loyaltyPointsTracks",
        icon: <Loyalty fontSize="small" />,
      },
      {
        name: "Water In Take",
        label: "Water In Take",
        link: "/admin/waterInTake",
        icon: <LocalDrink fontSize="small" />,
      },
      {
        name: "BMI Tracks",
        label: "BMI Tracks",
        link: "/admin/BMITracks",
        icon: <MedicalInformation fontSize="small" />,
      },
      {
        name: "Sports And Events",
        label: "Sports And Events",
        icon: <EmojiEvents fontSize="small" />,
        children: [
          {
            name: "Sports And Events",
            label: "Sports And Events",
            link: "/admin/sportsAndEvents",
            exact: true,
          },
          {
            name: "Event Participants",
            label: "Event Participants",
            link: "/admin/eventParticipants",
            exact: true,
          },
        ],
      },
      {
        name: "Business",
        label: "Business",
        icon: <Report fontSize="small" />,
        children: [
          {
            name: "Business",
            label: "Business",
            link: "/admin/businessPromote",
            exact: true,
          },
          {
            name: "Business Categories",
            label: "Business Categories",
            link: "/admin/businessCategories",
            exact: true,
          },
        ],
      },

      {
        name: "Open Door Requests",
        label: "Open Door Requests",
        link: "/admin/openDoorRequests",
        icon: <MeetingRoomIcon fontSize="small" />,
      },
      {
        name: "Reports",
        label: "Reports",
        icon: <Report fontSize="small" />,
        children: [
          {
            name: "activeMembers",
            label: "Active Members",
            link: "/admin/reports/activeMembers",
            exact: true,
          },
          {
            name: "lastOpeningDoor",
            label: "Active Member Last Opened Door",
            link: "/admin/reports/lastOpeningDoor",
            exact: true,
          },
        ],
      },
      {
        name: "Setting",
        label: "Setting",
        link: "/admin/setting",
        icon: <Settings fontSize="small" />,
      },
      {
        name: "Log",
        label: "Log",
        link: "/admin/log",
        icon: <DescriptionIcon fontSize="small" />,
      },
      {
        name: "Branches",
        label: "Branches",
        link: "/admin/branches",
        icon: <FoodBankIcon fontSize="small" />,
      },
    ],
  },
];

const NavLink = ({ selected, setSelected }) => {
  return linskData.map((link, index) => (
    <Link
      key={index}
      link={link}
      selected={selected}
      setSelected={setSelected}
    />
  ));
};

export default NavLink;
